import theme from './theme';

const button = {
  fontSize: theme.sizes.xs,
  fontWeight: String(theme.weight.base),
};

const layout = {
  widthNav: '298px',
  backgroundColor: theme.colors.bg,
  paddingVertical: theme.spacing.xl,
  paddingHorizontal: theme.spacing.xl3,
  sideWidth: '500px',
};

// using pixel values instead of theme values because
// the width is animated
const navGlobal = {
  width: '240px',
  widthClosed: '84px',
  paddingRight: theme.spacing.s,
};

const editor = {
  menuHeight: 84,
  sideMenuWidth: '460px',
  sideNavEditorWidth: '400px',
};

const navActions = {
  width: '335px',
  backgroundColor: theme.colors.bg,
};

const menuHeader = {
  width: '230px',
};

const text = {
  color: theme.colors.base,
};

const table = {
  header: {
    color: theme.colors.greyDark,
  },
};

const pageCard = {
  width: '240px',
  height: '200px',
};

const sectionCard = {
  width: '154px',
  height: '202px',
};

const form = {
  maxWidth: '675px',
};

const pagination = {
  backgroundColor: theme.colors.bg,
  linkColor: '#000000DE',
  linkHoverColor: '#94d500',
  disabledHover: '#d9d9d9',
  linkActive: '#94d500',
  jumpNextColor: '#ccc',
  jumpNextHoverColor: '#94d500',
  jumpPrevColor: '#000000DE',
  disabledLinkColor: '#ccc',
  quickJumperInputBgColor: theme.colors.bg,
  quickJumperInputHoverColor: '#94d500',
  quickJumperButtonBgColor: theme.colors.bg,
  quickJumperButtonColor: 'rgba(0, 0, 0, 0.65)',
  quickJumperButtonHAFColor: '#94d500',
  quickJumperButtonHAFBgColor: theme.colors.bg,
  simplePagerInputBgColor: theme.colors.bg,
  simplePagerInputHoverColor: '#94d500',
  simplePagerButtonColor: 'rgba(0, 0, 0, 0.65)',
  simplePagerButtonBgColor: theme.colors.bg,
  simplePagerButtonHAFColor: '#94d500',
  simplePagerButtonHAFBgColor: theme.colors.bg
};

export default {
  ...theme,
  components: {
    text,
    button,
    layout,
    navGlobal,
    navActions,
    menuHeader,
    table,
    pageCard,
    sectionCard,
    form,
    editor,
    pagination,
  },
};
